import axios from 'axios';
import { GoogletagManager } from "./";
import { useEffect, useState } from 'react';
import React from 'react';
import { useCookies } from 'react-cookie';
import { generateCookiesSettings } from "../utils";
var GoogleAndCookies = function () {
    var _a = useCookies(), cookies = _a[0], setCookie = _a[1];
    var _b = useState(false), loadGtm = _b[0], setLoadGtm = _b[1];
    useEffect(function () {
        axios
            .post('https://ctc.mymoria.de/cookieserv', { names: 'sessionID;userID' }, {
            withCredentials: true,
            headers: {
                customorigin: window.location.hostname === 'localhost' ? '' : window.location.origin,
            },
        })
            .then(function () { return setLoadGtm(true); })
            .catch(function (error) {
            console.info('set servser side cookies failed', error);
            console.info('set cookies via fallback');
            if (!cookies['sessionID']) {
                var _a = generateCookiesSettings(), id = _a.id, options = _a.options;
                setCookie('sessionID', id, options);
            }
            if (!cookies['userID']) {
                var _b = generateCookiesSettings(), id = _b.id, options = _b.options;
                setCookie('userID', id, options);
            }
            setLoadGtm(true);
        });
    }, []);
    return loadGtm ? React.createElement(GoogletagManager, null) : null;
};
export default GoogleAndCookies;
//# sourceMappingURL=GoogleAndCookies.js.map